import  { TPageConfig } from './index.d';

import Location from '@views/modules/map/MapLocation';
import MovePath from '@views/modules/map/MovePath';
import Area from '@views/modules/map/MapArea';
import GuardArea from '@views/modules/map/GuardArea';
import MovePathMode from '@views/modules/map/MovePathMode';
import LocationRecord from '@views/modules/map/LocationRecord';
import AppDownload from '@views/modules/download/AppDownload';
import UserLogout from '@views/modules/user/UserLogout';

import ApplyDetail from '@views/modules/apply/ApplyDetail';
import DeviceAuthorizationApply from '@views/modules/apply/DeviceAuthorizationApply';

import LocationSetting from '@views/modules/device/LocationSetting';
import LocationSettingDetail from '@views/modules/device/LocationSettingDetail';
import LocationFeedBack from '@views/modules/device/LocationFeedBack';
import DeviceQrcodeScan from '@views/modules/device/DeviceQrcodeScan';
import SmartGuardSetting from '@views/modules/device/SmartGuardSetting';
import CustomGuardSetting from '@views/modules/device/CustomGuardSetting';
import GuardSettingEntry from '@views/modules/device/GuardSettingEntry';
import EditGuardArea from '@views/modules/device/CustomGuardSetting/EditGuardArea';
import MyDevices from '@views/modules/device/MyDevices';
import DeviceSetPhone from '@views/modules/device/DeviceSetPhone';
import ParentPhoneSetting from '@views/modules/device/ParentPhoneSetting';
import SosPhoneSetting from '@views/modules/device/SosPhoneSetting';
import EditPhoneEntry from '@views/modules/device/EditPhoneEntry';
import ContactPhoneSetting from '@views/modules/device/ContactPhoneSetting';
import DeviceBindChild from '@views/modules/device/DeviceBindChild';
import DeviceInfoEntry from '@views/modules/device/DeviceInfoEntry';
import DeviceInfoAuthorization from '@views/modules/device/DeviceInfoAuthorization';
import DeviceBindMember from '@views/modules/device/DeviceBindMember';
import DeviceQrcodeInfo from '@views/modules/device/DeviceQrcodeInfo';
import DeviceBindApply from '@views/modules/device/DeviceBindApply';
import DeviceMessages from '@views/modules/device/DeviceMessages';
import DeviceBindResult from '@views/modules/device/DeviceBindResult';
import DevicePowerPlan from '@views/modules/device/DevicePowerPlan';

import NotificationGroupList from '@views/modules/notification/notificationGroup';
import NotificationList from '@views/modules/notification/notificationList';
import ClassDisableEntry from '@views/modules/device/ClassDisableEntry';
import ClassDisableSelfSetting from '@views/modules/device/ClassDisableSelfSetting';
import ClassDisableSchoolSetting from '@views/modules/device/ClassDisableSchoolSetting';
import ClassDisableSelfEdit from '@views/modules/device/ClassDisableSelfSetting/ClassDisableSelfEdit';
import LocationSettingFrequentedPlace from '@views/modules/device/LocationSettingFrequentedPlace';
import MapFrequentedPlace from '@views/modules/map/MapFrequentedPlace';

//路由名称规范：统一以驼峰式命名(旧的不改了， 新增的统一按照驼峰命名)
const pageConfig: TPageConfig = {
  location: {
    path: '/location',
    auth: true,
    component: Location
  },
  area: {
    path: '/area',
    auth: true,
    component: Area
  },
  guardArea: {
    path: '/guardArea',
    auth: true,
    component:GuardArea
  },
  movepath: {
    path: '/movepath',
    auth: true,
    component: MovePath
  },
  movepathmode: {
    path: '/movepathmode',
    auth: true,
    component: MovePathMode
  },
  applydetail: {
    path: '/applydetail',
    auth: true,
    component: ApplyDetail
  },
  locationrecord: {
    path: '/locationrecord',
    auth: true,
    component: LocationRecord
  },
  appdownload: {
    path: '/appdownload',
    auth: false,
    component: AppDownload
  },
  locationsetting: {
    path: '/locationsetting',
    auth: true,
    component: LocationSetting
  },
  locationsettingdetail: {
    path: '/locationsettingdetail',
    auth: true,
    component: LocationSettingDetail
  },
  locationSettingFrequentedPlace: {
    path: '/locationSettingFrequentedPlace',
    auth: true,
    component: LocationSettingFrequentedPlace
  },
  locationfeedback: {
    path: '/locationfeedback',
    auth: true,
    component: LocationFeedBack
  },
  deviceAuthorizationApply: {
    path: '/deviceAuthorizationApply',
    auth: true,
    component: DeviceAuthorizationApply
  },
  userlogout: {
    path: '/userlogout',
    auth: true,
    component: UserLogout
  },
  scan: {
    path: '/scan',
    auth: true,
    component: DeviceQrcodeScan
  },
  smartguardsetting: {
    path: '/smartguardsetting',
    auth: true,
    component: SmartGuardSetting
  },
  customguardsetting: {
    path: '/customguardsetting',
    auth: true,
    component: CustomGuardSetting
  },
  guardsettingentry: {
    path: '/guardsettingentry',
    auth: true,
    component: GuardSettingEntry
  },
  editguardarea: {
    path: '/editguardarea',
    auth: true,
    component: EditGuardArea
  },
  myDevices: {
    path: '/myDevices',
    auth: true,
    component: MyDevices
  },
  devicesetphone: {
    path: '/devicesetphone',
    auth: true,
    component: DeviceSetPhone
  },
  parentPhoneSetting: {
    path: '/parentPhoneSetting',
    auth: true,
    component: ParentPhoneSetting
  },
  sosPhoneSetting: {
    path: '/sosPhoneSetting',
    auth: true,
    component: SosPhoneSetting
  },
  editPhoneEntry: {
    path: '/editPhoneEntry',
    auth: true,
    component: EditPhoneEntry
  },
  contactPhoneSetting: {
    path: '/contactPhoneSetting',
    auth: true,
    component: ContactPhoneSetting
  },
  notificationList: {
    path: '/notificationList',
    auth: true,
    component: NotificationList
  },
  notificationGroupList: {
    path: '/notificationGroupList',
    auth: true,
    component: NotificationGroupList
  },
  devicebindchild: {
    path: '/devicebindchild',
    auth: true,
    component: DeviceBindChild
  },
  deviceInfoEntry: {
    path: '/deviceInfoEntry',
    auth: true,
    component: DeviceInfoEntry
  },
  deviceInfoAuthorization: {
    path: '/deviceInfoAuthorization',
    auth: true,
    component: DeviceInfoAuthorization
  },
  deviceBindMember: {
    path: '/deviceBindMember',
    auth: true,
    component: DeviceBindMember
  },
  deviceQrcodeInfo: {
    path: '/deviceQrcodeInfo',
    auth: true,
    component: DeviceQrcodeInfo
  },
  devicebindapply: {
    path: '/devicebindapply',
    auth: true,
    component: DeviceBindApply
  },
  deviceMessages: {
    path: '/deviceMessages',
    auth: true,
    component: DeviceMessages
  },
  devicebindresult: {
    path: '/devicebindresult',
    auth: true,
    component: DeviceBindResult
  },
  devicePowerPlan: {
    path: '/devicePowerPlan',
    auth: true,
    component: DevicePowerPlan
  },
  deviceClassDisableEntry: {
    path: '/deviceClassDisableEntry',
    auth: true,
    component: ClassDisableEntry
  },
  deviceClassDisableSelf: {
    path: '/deviceClassDisableSelf',
    auth: true,
    component: ClassDisableSelfSetting
  },
  deviceClassDisableSchool: {
    path: '/deviceClassDisableSchool',
    auth: true,
    component: ClassDisableSchoolSetting
  },
  deviceClassDisableSelfEdit: {
    path: '/deviceClassDisableSelfEdit',
    auth: true,
    component: ClassDisableSelfEdit
  },
  mapFrequentedPlace: {
    path: '/mapFrequentedPlace',
    auth: true,
    component: MapFrequentedPlace
  }
}

export default pageConfig;